var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('HeaderRow'),_c('v-row',[_c('v-col',{staticClass:"d-flex justify-center",attrs:{"cols":"12"}},[_c('PaypalButtons')],1)],1),_c('FooterRow')],1)}
var staticRenderFns = []

export { render, staticRenderFns }